import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { RecommendationsService } from '#/app/shared/services/api/recommendations.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a recommendation set exists and belongs to the tenant in the route.
 * Prevents route matching if the recommendation set doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const recommendationAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const recommendationsService = inject(RecommendationsService);
  const recommendationSetIdParam =
    _currentSnapshot?.paramMap.get('recommendationSetId') ?? '';

  return resolveResourceAccessGuardResult(
    recommendationSetIdParam,
    (recommendationSetIdSignal) =>
      recommendationsService.recommendationSetResource(
        recommendationSetIdSignal as Signal<string>,
      ),
  );
};
